module.exports = __webpack_public_path__ + "img/Slovenia.482961e6.svg";